/* Over ons: klik op een dier en het zegt iets. Eén tegelijk, verdwijnt vanzelf. */
(function () {
  if (typeof customElements === 'undefined' || customElements.get('about-pets')) return;
  customElements.define('about-pets', class extends HTMLElement {
    connectedCallback() {
      var pets = Array.from(this.querySelectorAll('.abh__pet')), timer;
      pets.forEach(function (p) {
        p.addEventListener('click', function () {
          pets.forEach(function (x) { x.classList.remove('is-say'); x.querySelector('.abh__say').textContent = ''; });
          var say = p.querySelector('.abh__say');
          say.textContent = p.getAttribute('data-say');
          void p.offsetWidth;
          p.classList.add('is-say');
          clearTimeout(timer);
          timer = setTimeout(function () { p.classList.remove('is-say'); say.textContent = ''; }, 2200);
        });
      });
    }
  });
})();
